// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteShopOrderItemRequestModel from '../../model/delete-shop-order-item-request-model';
import DeleteShopOrderItemRequestDTO from '../dto/delete-shop-order-item-request-dto';
import dtoSchema from '../schemas/delete-shop-order-item-request-schema';

export default abstract class DeleteShopOrderItemRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteShopOrderItemRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteShopOrderItemRequestDTO>): DeleteShopOrderItemRequestModel;
  static toModel(dto: DeepPartial<DeleteShopOrderItemRequestDTO> | undefined | null): DeleteShopOrderItemRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteShopOrderItemRequestDTO> | undefined | null): DeleteShopOrderItemRequestModel | undefined {
    return dto ? new DeleteShopOrderItemRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteShopOrderItemRequestModel> | DeleteShopOrderItemRequestModel): DeleteShopOrderItemRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteShopOrderItemRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteShopOrderItemRequestModel, can not map to DeleteShopOrderItemRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
